<div mat-tab-nav-bar [tabPanel]="tabPanel" class="miq-button-tabs">
  <ng-container *ngFor="let tab of tabItems">
    <ng-container *ngIf="tab.isActive; else inactiveButton">
      <button
        mat-tab-link
        class="button-tab__tab"
        [id]="'e2e-button-tab-' + tab.id"
        [disabled]="operationInProgress"
        [active]="true"
        (click)="tabSelected(tab)"
      >
        <ng-container>
          <span [matMenuTriggerFor]="menu" class="button-tab__label button-tab__label--active">
            {{ tab.label }}
            <mat-icon
              *ngIf="tab.icon"
              class="button-tab__icon-label"
              [svgIcon]="tab.icon"
              [matTooltip]="tab.iconTooltip"
            ></mat-icon>
          </span>

          <!-- OPEN CONTEXTUAL MENU - TRIGGER -->
          <a
            *ngIf="contextualMenuItems?.length > 0"
            class="button-tab__icon-menu"
            [id]="'e2e-button-tab-open-menu' + tab.id"
            [matMenuTriggerFor]="menu"
          >
            <mat-icon svgIcon="arrow-down-icon"></mat-icon>
          </a>
        </ng-container>
      </button>

      <!-- CONTEXTUAL MENU -->
      <mat-menu #menu="matMenu" class="button-tab__menu" backdropClass="button-tab__menu-backdrop">
        <button
          mat-menu-item
          *ngFor="let option of contextualMenuItems"
          [id]="'e2e-button-tab-menu-item-' + option.id"
          (click)="onClick(option, tab)"
        >
          {{ option.label }}
        </button>
      </mat-menu>
    </ng-container>

    <ng-template #inactiveButton>
      <button
        mat-tab-link
        class="button-tab__tab"
        [id]="'e2e-button-tab-' + tab.id"
        [disabled]="operationInProgress"
        (click)="tabSelected(tab)"
      >
        <div class="button-tab__label">
          {{ tab.label }}
          <mat-icon
            *ngIf="tab.icon"
            class="button-tab__icon-label"
            [svgIcon]="tab.icon"
            [matTooltip]="tab.iconTooltip"
          ></mat-icon>
        </div>
      </button>
    </ng-template>
  </ng-container>
</div>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
